const toCount = value => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getItemTotalQty = item => {
  const declaredTotal = Math.max(0, toCount(item?.total_qty));
  // Raw sum on purpose: a negative qty_remaining offsets an inflated scanned_qty,
  // so a corrupt row reports its real total instead of the over-scanned figure.
  const outstanding = toCount(item?.qty_remaining) + toCount(item?.scanned_qty);
  return Math.max(0, Math.max(declaredTotal, outstanding));
};

export const getItemCounts = item => {
  const total = getItemTotalQty(item);
  const scanned = Math.max(0, Math.min(toCount(item?.scanned_qty), total));
  return {total, scanned, remaining: Math.max(0, total - scanned)};
};

export const clampItemQuantities = item => {
  if (!item) return item;
  const {scanned, remaining} = getItemCounts(item);
  if (item.scanned_qty === scanned && item.qty_remaining === remaining) return item;
  return {...item, scanned_qty: scanned, qty_remaining: remaining};
};

export const isKitParent = item =>
  Array.isArray(item?.child_items) && item.child_items.length > 0;

export const getItemIdentity = item => {
  const orderItemId = item?.order_item_id;
  const productId = item?.product_id;
  if (orderItemId === undefined && productId === undefined) return null;
  return `${orderItemId ?? ''}::${productId ?? ''}`;
};

const sumOncePerItem = (items = [], getValue) => {
  const seen = new Set();
  let total = 0;
  items.forEach(item => {
    if (!item) return;
    const identity = getItemIdentity(item);
    if (identity !== null) {
      if (seen.has(identity)) return;
      seen.add(identity);
    }
    total += getValue(item);
  });
  return total;
};

export const getScannedUnitCount = (scannedItems = []) =>
  sumOncePerItem(scannedItems, item =>
    isKitParent(item) ? 0 : getItemCounts(item).scanned
  );

export const getUnscannedUnitCount = (unScannedItems = []) =>
  sumOncePerItem(unScannedItems, item => {
    if (isKitParent(item)) {
      return sumOncePerItem(item.child_items, child => getItemCounts(child).remaining);
    }
    return getItemCounts(item).remaining;
  });
